export interface VisibilityBadge {
  applicableDate: Date;
  showBadge: boolean;
}
